import { render, staticRenderFns } from "./ErrorBar.vue?vue&type=template&id=ab680f10&scoped=true&"
import script from "./ErrorBar.vue?vue&type=script&lang=ts&"
export * from "./ErrorBar.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorBar.vue?vue&type=style&index=0&id=ab680f10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab680f10",
  null
  
)

export default component.exports